import { interpolateColors } from '@services/utils';
export const mockSankeyData = {
  nodes: [{
    name: 'Farms',
    depth: 0,
    value: '355'
  }, {
    name: 'Chipyard 1',
    depth: 1,
    value: '75'
  }, {
    name: 'Chipyard 2',
    depth: 1,
    value: '145'
  }, {
    name: 'Starch Mill 1',
    depth: 2,
    value: '135'
  }, {
    name: 'Factory 1',
    depth: 3,
    value: '75'
  }, {
    name: 'Starch Mill 2',
    depth: 2,
    value: '100'
  }, {
    name: 'Factory 2',
    depth: 3,
    value: '40'
  }],
  links: [{
    source: 'Farms',
    target: 'Chipyard 1',
    value: 100
  }, {
    source: 'Farms',
    target: 'Chipyard 2',
    value: 25
  }, {
    source: 'Farms',
    target: 'Chipyard 2',
    value: 50
  }, {
    source: 'Farms',
    target: 'Chipyard 1',
    value: 45
  }, {
    source: 'Chipyard 1',
    target: 'Starch Mill 1',
    value: 100
  }, {
    source: 'Starch Mill 1',
    target: 'Factory 1',
    value: 75
  }, {
    source: 'Farms',
    target: 'Starch Mill 1',
    value: 35
  }, {
    source: 'Farms',
    target: 'Starch Mill 2',
    value: 100
  }, {
    source: 'Chipyard 2',
    target: 'Factory 2',
    value: 40
  }]
};
const createMockPlace = (id: string, name: string, description: string) => ({
  id,
  name,
  description,
  type: 'Place',
  phone: '+819012121212',
  address: '7, Prampong Road',
  lnglat: {
    type: 'Point',
    coordinates: [100.47, 13.7563]
  },
  created_at: '2023-12-12T14:58:31.287+09:00',
  kind: 'factory',
  annual_production_target: 1000,
  annual_production_target_unit: 'tons',
  capacity: 500,
  capacity_unit: 'tons'
});
export const mockChartData = {
  total_sold: 10000000,
  destinations: [{
    place: createMockPlace('687a9081-9add-46e5-b08c-892f23e56883', 'Sipes, Satterfield and Brown', 'Example of description of goods'),
    from_district: 'klong khlung',
    from_subdistrict: 'khlong sombun',
    amount: '100',
    amount_type: 'tons',
    percentage: '10'
  }, {
    place: createMockPlace('12689453-69f9-446c-9d57-01cd989594d9', 'Thiel-Ritchie', 'Example of description of goods'),
    from_district: 'klong khlung',
    from_subdistrict: 'wang sai',
    amount: '10',
    amount_type: 'tons',
    percentage: '1'
  }, {
    place: createMockPlace('0362b44e-55db-492e-8d37-28d8a2922f5a', 'Mayer-Breitenberg', 'Example of description of goods'),
    from_district: 'klong khlung',
    from_subdistrict: 'klong khlung 3',
    amount: '60',
    amount_type: 'tons',
    percentage: '6'
  }, {
    place: createMockPlace('4829bec8-080b-43b6-9270-2eff11991498', 'Gerhold, Runte and Ankunding', 'Example of description of goods'),
    from_district: 'klong lan',
    from_subdistrict: 'phatthana',
    amount: '200',
    amount_type: 'tons',
    percentage: '20'
  }, {
    place: createMockPlace('11111111-9add-46e5-b08c-892f23e56883', 'fake 1 name', 'fake 1 description'),
    from_district: 'klong lan',
    from_subdistrict: 'klong lan 2',
    amount: '90',
    amount_type: 'tons',
    percentage: '9'
  }, {
    place: createMockPlace('22222222-9add-46e5-b08c-892f23e56883', 'fake 2 name', 'fake 2 description'),
    from_district: 'pang sila',
    from_subdistrict: 'thong',
    amount: '35',
    amount_type: 'tons',
    percentage: '3.5'
  }, {
    place: createMockPlace('33333333-9add-46e5-b08c-892f23e56883', 'fake 3 name', 'fake 3 description'),
    from_district: 'tokyo',
    from_subdistrict: 'kiba',
    amount: '100',
    amount_type: 'tons',
    percentage: '10'
  }, {
    place: createMockPlace('44444444-9add-46e5-b08c-892f23e56883', 'fake 4 name', 'fake 4 description'),
    from_district: 'tokyo',
    from_subdistrict: 'kiba',
    amount: '100',
    amount_type: 'tons',
    percentage: '10'
  }, {
    place: createMockPlace('55555555-9add-46e5-b08c-892f23e56883', 'fake 5 name', 'fake 5 description'),
    from_district: 'tokyo',
    from_subdistrict: 'kiba',
    amount: '100',
    amount_type: 'tons',
    percentage: '10'
  }, {
    place: createMockPlace('66666666-9add-46e5-b08c-892f23e56883', 'fake 6 name', 'fake 6 description'),
    from_district: 'tokyo',
    from_subdistrict: 'kiba',
    amount: '100',
    amount_type: 'tons',
    percentage: '10'
  }, {
    place: createMockPlace('77777777-9add-46e5-b08c-892f23e56883', 'fake 7 name', 'fake 7 description'),
    from_district: 'tokyo',
    from_subdistrict: 'kiba',
    amount: '100',
    amount_type: 'tons',
    percentage: '10'
  }]
};
export const mockLegendColors = interpolateColors(mockSankeyData.nodes);